module.exports = __webpack_public_path__ + "img/wrong.6de3f0d3.png";